import React from "react";

export default function Footer() {
  return (
    <p className="footer">
      Coded by{" "}
      <a href="https://github.com/LeticiAz" target="_blank" rel="noreferrer">
        Letícia Azevedo
      </a>{" "}
      is open-sourced on{" "}
      <a
        href="https://github.com/LeticiAz/FinalWeatherApp_SheCodeProject"
        target="_blank"
        rel="noreferrer"
      >
        GitHub
      </a>{" "}
      and hosted by{" "}
      <a
        href="https://finalweatherapp-shecode.netlify.app/"
        target="_blank"
        rel="noreferrer"
      >
        Netlify
      </a>{" "}
    </p>
  );
}
